module.exports = __webpack_public_path__ + "static/media/kumquat.c8d9bc0e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/kumquat.jpeg
// module id = 2044
// module chunks = 0